// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1346": "e6b0a3e1","3414": "8e4d7691","8584": "16ee0354",}[chunkId] + ".css"
}